var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[_c('p',{staticClass:"green--text font-weight-bold mb-3 text-h6"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"primary--text font-weight-bold mb-1"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }